export const SERVER_GENERAL_ERROR_MESSAGE = 'Something appears to be wrong. Please try again in a few minutes.';
